const personTypes = [
  {
    id: 1,
    name: 'Persona Física'
  },
  {
    id: 0,
    name: 'Persona Juridica'
  }
]
export default personTypes
